import React from 'react';
import s from './MobilePortal.module.css';

function PillS({ type, children }) {
  const cls = { green: s.pillGreen, amber: s.pillAmber, blue: s.pillBlue, red: s.pillRed }[type] || s.pillGreen;
  return <span className={`${s.pill} ${cls}`}>{children}</span>;
}

function MpFrame({ title, showClose, children, label }) {
  return (
    <div className={s.phoneWrap}>
      <div className={s.mobilePortal}>
        <div className={s.mpBar}>
          <div className={s.mpLogo}>
            <div className={s.mpGem}>F</div>
            <span className={s.mpName}>{title}</span>
          </div>
          <i className={`ti ${showClose ? 'ti-x' : 'ti-bell'} ${s.mpBell}`} />
        </div>
        <div className={s.mpBody}>{children}</div>
      </div>
      <div className={s.phoneLabel}>{label}</div>
    </div>
  );
}

export default function MobilePortal() {
  return (
    <div className={s.phoneRow}>
      {/* Screen A: Home */}
      <MpFrame title="Finigenie" label="Home screen">
        <div className={s.mpWelcome}>
          <div className={s.mwName}>Bharat Petro Supplies</div>
          <div className={s.mwSub}>GSTIN: 33AABCB1234F1ZX</div>
          <div className={s.mwStats}>
            <div className={s.mwStat}>
              <span className={s.msval}>6</span>
              <span className={s.mslbl}>Invoices</span>
            </div>
            <div className={s.mwStat}>
              <span className={s.msval} style={{ color: '#FAC775' }}>1</span>
              <span className={s.mslbl}>Pending</span>
            </div>
            <div className={s.mwStat}>
              <span className={s.msval}>₹18L</span>
              <span className={s.mslbl}>Due soon</span>
            </div>
          </div>
        </div>

        <div className={s.mpActionRow}>
          {[
            { icon: 'ti-upload', lbl: 'Submit invoice' },
            { icon: 'ti-bolt', lbl: 'Early payment' },
            { icon: 'ti-file-invoice', lbl: 'My invoices' },
            { icon: 'ti-user-circle', lbl: 'My profile' },
          ].map(a => (
            <div key={a.lbl} className={s.mpAction}>
              <i className={`ti ${a.icon}`} />
              <span className={s.maLbl}>{a.lbl}</span>
            </div>
          ))}
        </div>

        <div className={s.mpSection}>
          <div className={s.mpsTitle}>Recent invoices</div>

          <div className={s.invCard}>
            <div className={s.icRow}>
              <span className={s.icNum}>INV-2024-1183</span>
              <PillS type="green">Payment cleared</PillS>
            </div>
            <div className={s.icSub}>₹18,40,000 · Submitted 02 Jul</div>
            <div className={s.icProgress}><div className={s.icpFill} style={{ width: '100%' }} /></div>
            <div className={s.icSteps}><span>Submitted</span><span>Validated</span><span>Approved</span><span>Paid</span></div>
          </div>

          <div className={s.invCard}>
            <div className={s.icRow}>
              <span className={s.icNum}>INV-2024-1171</span>
              <PillS type="blue">Finance review</PillS>
            </div>
            <div className={s.icSub}>₹9,10,000 · Submitted 28 Jun</div>
            <div className={s.icProgress}><div className={s.icpFill} style={{ width: '65%' }} /></div>
            <div className={s.icSteps}><span>Submitted</span><span>Validated</span><span style={{ color: '#185FA5', fontWeight: 600 }}>Approved</span><span>Paid</span></div>
          </div>

          <div className={s.invCard}>
            <div className={s.icRow}>
              <span className={s.icNum}>INV-2024-1159</span>
              <PillS type="amber">Doc missing</PillS>
            </div>
            <div className={s.icSub}>₹4,20,000 · Submitted 20 Jun</div>
            <div className={s.icProgress}><div className={s.icpFill} style={{ width: '30%', background: '#EF9F27' }} /></div>
            <div className={s.icSteps}><span>Submitted</span><span style={{ color: '#633806', fontWeight: 600 }}>Action needed</span><span /><span /></div>
          </div>
        </div>
      </MpFrame>

      {/* Screen B: Invoice detail + missing doc */}
      <MpFrame title="Invoice detail" showClose label="Invoice detail + action">
        <div className={s.alertBox}>
          <div className={s.alertTitle}><i className="ti ti-alert-triangle" /> Action required</div>
          <div className={s.alertSub}>NOC document missing. Upload to resume processing.</div>
        </div>

        <div className={s.invCard} style={{ marginBottom: 8 }}>
          <div className={s.icRow}>
            <span className={s.icNum}>INV-2024-1159</span>
            <span className={s.icAmt}>₹4,20,000</span>
          </div>
          <div className={s.icSub}>Submitted 20 Jun 2026</div>
          <div className={s.detailGrid}>
            <div className={s.detailCell}><div className={s.dcLbl}>GST</div><div className={s.dcVal}>Validated</div></div>
            <div className={s.detailCell}><div className={s.dcLbl}>PO match</div><div className={s.dcVal}>Matched</div></div>
            <div className={s.detailCell}><div className={s.dcLbl}>Bank A/C</div><div className={s.dcVal}>Verified</div></div>
            <div className={`${s.detailCell} ${s.detailCellWarn}`}><div className={s.dcLblWarn}>NOC</div><div className={s.dcValWarn}>Missing</div></div>
          </div>
          <div style={{ fontSize: 10, color: '#888', marginTop: 4 }}>
            Compliance score: <span style={{ color: '#854F0B', fontWeight: 600 }}>62/100</span>
          </div>
        </div>

        <div className={s.uploadBox}>
          <div className={s.uploadTitle}>Upload missing document</div>
          <div className={s.uploadZone}>
            <i className="ti ti-cloud-upload" style={{ fontSize: 22, color: '#3B6D11', display: 'block', marginBottom: 4 }} />
            <div style={{ fontSize: 11, color: '#3B6D11', fontWeight: 500 }}>Tap to upload NOC</div>
            <div style={{ fontSize: 10, color: '#5F5E5A', marginTop: 2 }}>PDF, JPG or PNG · max 5 MB</div>
          </div>
        </div>
        <button className={s.applyBtn}>Submit document</button>
      </MpFrame>

      {/* Screen C: Early payment applied */}
      <MpFrame title="Early payment" showClose label="Early pay confirmation">
        <div className={s.epDark}>
          <div className={s.epDarkLabel}>AMOUNT YOU RECEIVE TODAY</div>
          <div className={s.epDarkVal}>₹17,56,200</div>
          <div className={s.epDarkSub}>vs ₹18,40,000 on 15 Jul 2026</div>
          <div className={s.epPills}>
            <div className={s.epPill}><div className={s.epPillVal}>13 days</div><div className={s.epPillLbl}>early</div></div>
            <div className={s.epPill}><div className={s.epPillVal}>4.5%</div><div className={s.epPillLbl}>annual rate</div></div>
            <div className={s.epPill}><div className={s.epPillVal} style={{ color: '#FAC775' }}>₹83,800</div><div className={s.epPillLbl}>discount</div></div>
          </div>
        </div>

        <div className={s.epBreakdown}>
          <div className={s.ebTitle}>Payment to your account</div>
          <div className={s.ebRow}><span style={{ color: '#888' }}>Invoice amount</span><span style={{ fontWeight: 500 }}>₹18,40,000</span></div>
          <div className={s.ebRow}><span style={{ color: '#888' }}>Early payment discount</span><span style={{ color: '#A32D2D', fontWeight: 500 }}>− ₹83,800</span></div>
          <div className={s.ebRowFinal}><span style={{ fontWeight: 600 }}>You receive</span><span style={{ fontWeight: 700, color: '#0F6E56' }}>₹17,56,200</span></div>
          <div style={{ marginTop: 6, fontSize: 10, color: '#888' }}>Bank: ICICI ****4421 · Today, 3 Jul 2026</div>
        </div>

        <button className={s.applyBtn}>Confirm early payment</button>
        <div style={{ fontSize: 10, color: '#888', textAlign: 'center', marginTop: 8 }}>
          By confirming, you accept the early payment terms. This cannot be undone.
        </div>
      </MpFrame>
    </div>
  );
}
